export const getFileType = (fileName: string): string => {
  const ext = fileName.split('.').pop()?.toUpperCase()
  return ext || 'FILE'
}

export const generateUploadId = (): string => {
  return `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`
}
